<p-dialog header="Title" (onHide)="closeDialog()" [(visible)]="display_dialog_info" [modal]="true"
  [breakpoints]="{'1100px': '75vw', '640px': '100vw'}">
  <ng-template pTemplate="header">
    <h3 id="title-info-dialog">{{popupsInfo?.title}}</h3>
  </ng-template>
  <p id="content-info-dialog" [innerHTML]="safeHtml"></p>
  <ng-template pTemplate="footer">
    <div>
      <button pButton pRipple (click)="closeDialog()" type="button" id="close"
        label="{{ 'activate_account.dialogInfo_fermer' | translate }}" icon="pi pi-times" class="p-button-outlined hidden md:inline-block"
        iconPos="left"></button>
    </div>
  </ng-template>
</p-dialog>
